module.exports = __webpack_public_path__ + "img/empire.72321da6.svg";